module.exports = __webpack_public_path__ + "img/组 696@2x.8baa5464.webp";